import styled from 'styled-components';

const FooterBox = styled.div`
  background-color: #e96969;
  bottom: 0;
  height: 30px;
  position: fixed;
  width: 100%;
  z-index: 999;
`;

export { FooterBox };